import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale} from  "react-datepicker";
import {mk} from 'date-fns/locale';
import './DatePicerComponent.css'


export const DatePickerComponent = ({selectedDate, onChange, placeholder, maxDate, minDate}) => {
    registerLocale('mk', mk);
    // console.log(selectedDate)

    return (
        <div>
            <DatePicker
                className="candidate_data"
                selected={selectedDate && new Date(selectedDate)}
                        onChange={onChange}
                        onYearChange={onChange}
                        onMonthChange={onChange}
                        dateFormat='dd.MM.yyyy'
                        maxDate={maxDate}
                        minDate={minDate}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        locale="mk"
                        placeholderText={placeholder}
                        popperClassName="date-picker"
            />
        </div>
    )
}





